<script>
export default {
  name: 'KanbanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- 3 colunas com alturas diferentes: 80% / 100% / 50% -->
    <rect x="2" y="2" width="6" height="16" rx="2" :fill="color" />
    <rect x="9" y="2" width="6" height="20" rx="2" :fill="color" />
    <rect x="16" y="2" width="6" height="10" rx="2" :fill="color" />
  </svg>
</template>
